// extracted by mini-css-extract-plugin
module.exports = {"drawer":"BottomDrawerSave_drawer__3iEHl","actions":"BottomDrawerSave_actions__1dHG-"};